module.exports = __webpack_public_path__ + "img/toolbox.2bbf519b.svg";